import React, { useEffect, useRef, useState } from "react";
import { Box, MainButton, MainTitle } from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import Pdf from "react-native-pdf";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import normalize from "app/utils/normalize";
import { getUserCampaignCertificate } from "@microdoing/shared/services/userCampaign/selectors";
import { useSelector } from "react-redux";
import Loader from "app/components/common/Loader";
import { useNavigation } from "@react-navigation/native";

const certificateRatio = 220 / 296;

interface IProps {}

const ProfileCertification = ({}: IProps) => {
  const [pdfWidth, setPdfWidth] = useState(100);
  const [pdfHeight, setPdfHeight] = useState(100);
  const canvasPdfRef = useRef(null);

  const certificationUrl = useSelector(getUserCampaignCertificate);

  const navigation = useNavigation();

  const onPdfLoaded = () => {
    if (canvasPdfRef.current) {
      canvasPdfRef.current.style.borderRadius = "10px";
      // canvasPdfRef.current.style.width = pdfWidth;
      // canvasPdfRef.current.style.height = pdfWidth * certificateRatio;
    }
  };

  useEffect(() => {
    onPdfLoaded();
  }, [canvasPdfRef.current]);

  const findDimensions = ({ height, width }, setWidth, setHeight) => {
    setWidth(width);
    setHeight(width * certificateRatio);
  };

  const handleOnLayoutPdf = event => {
    findDimensions(event.nativeEvent.layout, setPdfWidth, setPdfHeight);
  };

  const navigateToCertificate = () => {
    navigation.navigate("CertificateScreen");
  };

  const options = {
    cMapUrl: certificationUrl,
    cMapPacked: true,
  };

  const renderPdf = () => {
    if (isWebDesktop) {
      return (
        <Pdf
          paramsDocument={{
            onLoadSuccess: onPdfLoaded,
            options: options,
            loading: (
              <Box
                backgroundColor="neutral.white"
                width={pdfWidth}
                height={pdfWidth * certificateRatio}
                justifyContent="center"
              >
                <Loader size={normalize(30)} />
              </Box>
            ),
            renderMode: "canvas",
            file: certificationUrl,
          }}
          paramsPage={{
            onLoadSuccess: onPdfLoaded,
            canvasRef: canvasPdfRef,
            width: pdfWidth,
            renderAnnotationLayer: false,
            renderMode: "canvas",
          }}
        />
      );
    }
    return (
      <Pdf
        trustAllCerts={false}
        source={{ uri: certificationUrl }}
        // singlePage
        style={{
          backgroundColor: "transparent",
          overflow: "visible",
          width: pdfWidth,
          height: pdfHeight,

          borderRadius: 8,
        }}
      />
    );
  };

  return (
    <Box
      flex={1}
      width="100%"
      marginBottom="sm"
      paddingHorizontal="xm"
      paddingVertical="xm"
      borderRadius={8}
      backgroundColor="neutral.white"
    >
      <MainTitle variant="l6-bold" marginBottom="xm">
        {i18n.t("certification")}
      </MainTitle>
      <Box
        overflow="visible"
        backgroundColor="neutral.white"
        onLayout={handleOnLayoutPdf}
        marginBottom="xm"
        borderRadius={10}
        borderColor="neutral.transparent.white.80"
      >
        {renderPdf()}
      </Box>
      <MainButton
        margin="null"
        onPress={navigateToCertificate}
        text={i18n.t("get-your-certification")}
      />
    </Box>
  );
};

export default ProfileCertification;
